export default __webpack_public_path__ + "static/media/sidebar-infohub.b1821fb1.svg";